import { useState } from "react";
import { SharedLiveTranscript } from "./SharedLiveTranscript";
import { SharedReviewTranscript } from "./SharedReviewTranscript";

export function SharedTranscriptPage({ token }: { token: string }) {
  const [liveFallback, setLiveFallback] = useState(false);
  return liveFallback
    ? <SharedLiveTranscript token={token} />
    : <SharedReviewTranscript token={token} onNotReviewedShare={() => setLiveFallback(true)} />;
}
